import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin.js';
import { gsap } from 'gsap';

gsap.registerPlugin(MorphSVGPlugin);

function SvgAnim({ node }) {
	const tl = gsap.timeline({ repeat: -1 });

	tl.to('#shape-1', {
		// top left corner
		morphSVG: { shape: '#shape-2', type: 'linear' },
		duration: 0.8,
		ease: 'power3.out',
		delay: 0.8,
	})
		.to('#shape-1', {
			fill: '#FF524B',
			duration: 0.25,
		})
		.to('#shape-1', {
			// bottom right corner
			morphSVG: { shape: '#shape-4', type: 'linear', shapeIndex: 6 },
			duration: 0.8,
			ease: 'power4.out',
			delay: 0.8,
		})
		.to('#shape-1', {
			fill: '#64D995',
			duration: 0.25,
		})
		.to('#shape-1', {
			// double squares
			morphSVG: {
				shape: '#shape-5',
				type: 'linear',
				origin: '100% 00%',
			},
			duration: 0.8,
			ease: 'power3.out',
			delay: 0.8,
		})
		.to('#shape-1', {
			fill: '#006BFF',
			duration: 0.25,
		})
		.to('#shape-1', {
			// top left corner
			morphSVG: { shape: '#shape-2', type: 'linear' },
			duration: 0.8,
			ease: 'power3.out',
			delay: 0.8,
		})
		.to('#shape-1', {
			fill: '#64D995',
			duration: 0.25,
		})
		.to('#shape-1', {
			morphSVG: { shape: '#shape-1', type: 'linear' },
			duration: 0.8,
			ease: 'power3.out',
			delay: 0.8,
		})
		.to('#shape-1', {
			fill: '#006BFF',
			duration: 0.25,
		});

	return () => {};
}

export default SvgAnim;


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
